import { jsx as _jsx } from "react/jsx-runtime";
import { MenuItem as HeadlessMenuItem } from '@headlessui/react';
export const MenuItem = ({ children, ...props }) => {
    return _jsx(HeadlessMenuItem, { ...props, children: children });
};
